import { Menu, Row } from "antd";
import styled from "styled-components";

export const Columns = styled(Row)`
  flex-direction: column;
`;

export const CustomMenu = styled(Menu)`
  top: -20px;
`;
